import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";
import { useAddKoBiddingMutation } from "../liveBidding/api";

const activations = createApi({
    baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
    reducerPath: "api.activations",
    tagTypes: ["activations"],
    endpoints: (builder) => ({

        getKeywords: builder.query<any, { client: any, page: any, page_size: any, workspace_id: any, match_type: any }>({
            query: ({ client, page, page_size, workspace_id, match_type }) => {
                return {
                    url: "/activations/keywords",
                    method: "POST",
                    body: JSON.stringify(
                        {
                            client,
                            page,
                            page_size,
                            workspace_id,
                            match_type
                        }
                    ),
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                        "Cache-Control": "no-cache",
                    },
                };
            },
            providesTags: ["activations"],
        }),


        // SCRAPING
        addScraping: builder.mutation<any, { keywords: string[], country: string, frequency: string, device: string, mode: string, home_language: string, platform_scraping: string[] }>({
            query: (arg) => ({
                url: '/activations/scraping/add',
                method: 'POST',
                body: arg,
                headers: {
                    'Cache-Control': 'max-age=0',
                    Accept: 'application/json',
                },
            }),
        }),

        disableScraping: builder.mutation<any, { id: number }>({
            query: ({ id }) => ({
                url: '/activations/scraping/disable',
                method: 'PUT',
                body: JSON.stringify({ id }),
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),




        // ACTIVE MODE
        addActiveMode: builder.mutation<any, Partial<any>>({
            query: (newStrategy) => ({
                url: '/activations/active-mode/add',
                method: 'POST',
                body: newStrategy,
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),
        disableActiveMode: builder.mutation<any, { id: number; workspace_id: string }>({
            query: ({ id, workspace_id }) => ({
                url: '/activations/active-mode/disable',
                method: 'POST',
                body: JSON.stringify({ id, workspace_id }),
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),



        // KO BIDDING MANUAL
        addKoBiddingManualMaxCpc: builder.mutation<any, Partial<any>>({
            query: (data) => ({
                url: "/activations/ko-bidding-manual/add/max-cpc",
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),
        disableKoBiddingManualMaxCpc: builder.mutation<any, { id: number }>({
            query: ({ id }) => ({
                url: "/activations/ko-bidding-manual/disable/max-cpc",
                method: "POST",
                body: JSON.stringify({ id }),
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),
        updateKoBiddingManualMaxCpc: builder.mutation<any, Partial<any>>({
            query: (data) => ({
                url: "/activations/ko-bidding-manual/update/max-cpc",
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),



        // KO BIDDING AUTO
        addKoBiddingAutoMaxCpc: builder.mutation<any, Partial<any>>({
            query: (data) => ({
                url: "/activations/ko-bidding-auto/add/max-cpc",
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),
        disableKoBiddingAutoMaxCpc: builder.mutation<any, { id: number }>({
            query: ({ id }) => ({
                url: "/activations/ko-bidding-auto/disable/max-cpc",
                method: "POST",
                body: JSON.stringify({ id }),
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),
        updateKoBiddingAutoMaxCpc: builder.mutation<any, Partial<any>>({
            query: (data) => ({
                url: "/activations/ko-bidding-auto/update/max-cpc",
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/json",
                },
            }),
        }),

    }),
});

export const {
    useGetKeywordsQuery,

    // SCRAPING
    useAddScrapingMutation,
    useDisableScrapingMutation,

    // ACTIVE MODE
    useAddActiveModeMutation,
    useDisableActiveModeMutation,

    // KO BIDDING MANUAL
    useAddKoBiddingManualMaxCpcMutation,
    useDisableKoBiddingManualMaxCpcMutation,
    useUpdateKoBiddingManualMaxCpcMutation,

    // KO BIDDING AUTO
    useAddKoBiddingAutoMaxCpcMutation,
    useDisableKoBiddingAutoMaxCpcMutation,
    useUpdateKoBiddingAutoMaxCpcMutation

} = activations;

export default activations;
